module.exports = __webpack_public_path__ + "sr.svg?6d79b69b3d34dc97629262e4720439c4";